import React, { FC, useEffect } from "react";
import { Map } from "immutable";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { seedDemoDetailedShipments } from "../../../../reduxFolder/reducers/storage";
import { authSelectUnits } from "../../../../reduxFolder/selectors/globalSelectors";
import InventoryList from "../../../Inventory/components/InventoryList";
import { demoDetailedShipments, demoInventoryItems } from "./demoFixtures";
import DemoFrame from "./DemoFrame";
import { FadeWrapper } from "./DemoShipments.styles";
import { useDemoHint } from "./useDemoHint";

const notInCart = () => false;

// Sample rows for the "Items" search view on a settled-empty account: the
// inventory items of the demo inventory shipment, browse-only like all demo
// content (isDemo flips the item panel into hint-only mode).
const DemoInventoryItems: FC = () => {
  const { t } = useTranslation("common");
  const units = useSelector(authSelectUnits);
  const dispatch = useDispatch();
  const showDemoHint = useDemoHint();

  // Pre-seed the detail cache so clicking a sample item opens its panel
  // without fetching (same seed DemoShipments performs on the parcels list).
  useEffect(() => {
    dispatch(seedDemoDetailedShipments(demoDetailedShipments));
  }, [dispatch]);

  return (
    <DemoFrame
      title={t("parcels.demo.itemsTitle")}
      subtitle={t("parcels.demo.itemsSubtitle")}
    >
      <FadeWrapper>
        <InventoryList
          units={units}
          items={demoInventoryItems}
          selectedItems={{}}
          disabled={false}
          getIsItemInCart={notInCart}
          handleSelectItems={showDemoHint}
          shipment={Map()}
          isInventoryItemsSearchVariant
          isDemo
        />
      </FadeWrapper>
    </DemoFrame>
  );
};

export default DemoInventoryItems;
